import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import React from 'react';

class CountdownTimer extends React.Component {
  static defaultProps = {
    tickLength: 1000,
  };

  static propTypes = {
    complete: PropTypes.func.isRequired,
    seconds: PropTypes.number.isRequired,
    start: PropTypes.func.isRequired,
    tickLength: PropTypes.number,
    // Useful for automatically restarting a timer when the props change
    // If this changes, the timer will reset
    timerId: PropTypes.any,
  };

  state = {
    timeLeft: 0,
    timerStarted: false,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.timerId !== this.props.timerId) {
      this.stopTimer();
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  startTimer = () => {
    this.props.start();
    this.setState({timeLeft: this.props.seconds, timerStarted: true});
    this.interval = setInterval(this.tick, this.props.tickLength);
  };

  stopTimer = () => {
    if (!this.state.timerStarted) {
      return;
    }
    clearInterval(this.interval);
    this.setState({timeLeft: this.props.seconds, timerStarted: false});
    this.props.complete();
  };

  tick = () => {
    if (this.state.timerStarted && this.state.timeLeft < 1) {
      this.stopTimer();
    } else {
      this.setState({timeLeft: this.state.timeLeft - 1});
    }
  };

  render() {
    return (
      <div>
        {
          this.state.timerStarted ? this.state.timeLeft :
          <button className='btn btn-primary' onClick={this.startTimer}><FormattedMessage id="general.start" /></button>
        }
      </div>
    );
  }
}

export default CountdownTimer;
